function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  strokeMiterlimit: 8
}, React.createElement("rect", {
  className: "icon-secondary",
  x: 24.511,
  y: 6.3037,
  width: 3.5457,
  height: 14.158,
  fill: "#adb9ca"
}), React.createElement("rect", {
  className: "icon-primary",
  x: 30.374,
  y: 10.481,
  width: 4.1067,
  height: 9.9804,
  fill: "#ecaec6"
}), React.createElement("g", {
  className: "icon-tertiary",
  transform: "translate(1.0187 .89886)",
  stroke: "#002060"
}, React.createElement("rect", {
  className: "icon-tertiary",
  x: 11.493,
  y: 12.556,
  width: 3.8503,
  height: 7.0067,
  fill: "#fff"
}), React.createElement("rect", {
  className: "icon-tertiary",
  x: 17.469,
  y: 9.4765,
  width: 3.9498,
  height: 10.086,
  fill: "#fff"
}), React.createElement("rect", {
  x: 23.516,
  y: 5.5638,
  width: 3.9452,
  height: 13.998,
  fill: "none"
}), React.createElement("rect", {
  x: 29.475,
  y: 9.5241,
  width: 3.9876,
  height: 10.039,
  fill: "none"
})));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  strokeMiterlimit: 10
}, React.createElement("g", null, React.createElement("path", {
  className: "icon-tertiary",
  shapeRendering: "crispEdges",
  d: "m8.9669 20.166c0-1.3563 1.1129-2.4558 2.4863-2.4558h11.603c1.3734 0 2.4863 1.0995 2.4863 2.4558v9.8234c0 1.3563-1.1129 2.4558-2.4863 2.4558h-11.603c-1.3734 0-2.4863-1.0995-2.4863-2.4558z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m11.448 17.71h11.612c1.371 0 2.4816 1.0731 2.4816 2.3971v2.7484h-16.575v-2.7484c0-1.3241 1.1105-2.3971 2.4816-2.3971z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m11.448 17.71h11.612c1.371 0 2.4816 1.0731 2.4816 2.3971v2.7484h-16.575v-2.7484c0-1.3241 1.1105-2.3971 2.4816-2.3971z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), React.createElement("path", {
  className: "icon-tertiary",
  d: "m5.5882 18.082c0-1.368 1.1357-2.477 2.5371-2.477h11.84c1.4015 0 2.5371 1.109 2.5371 2.477v9.9081c0 1.368-1.1357 2.477-2.5371 2.477h-11.84c-1.4015 0-2.5371-1.109-2.5371-2.477z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m8.1331 15.605h11.612c1.371 0 2.4815 1.122 2.4815 2.5061v2.8733h-16.575v-2.8733c0-1.3842 1.1105-2.5061 2.4815-2.5061z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "icon-secondary",
  fill: "#adb9ca",
  strokeMiterlimit: 10
}, React.createElement("rect", {
  x: 8.4791,
  y: 22.517,
  width: 2.1311,
  height: 2.105
}), React.createElement("rect", {
  x: 8.5851,
  y: 26.407,
  width: 2.1311,
  height: 2.105
}));
var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  shapeRendering: "crispEdges",
  d: "m8.5821 17.816c0-0.18774 0.14575-0.34001 0.32307-0.34001h10.285c0.17732 0 0.32307 0.15228 0.32307 0.34001v1.3606c0 0.18774-0.14575 0.34001-0.32307 0.34001h-10.285c-0.17732 0-0.32307-0.15228-0.32307-0.34001z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  shapeRendering: "crispEdges",
  d: "m8.1381 15.605h11.835c1.3973 0 2.5291 1.1352 2.5291 2.5357v2.9073h-16.893v-2.9073c0-1.4005 1.1318-2.5357 2.5291-2.5357z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});
var _ref9 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  stroke: "#002060"
}, React.createElement("path", {
  d: "m13.063 23.538h6.9522",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeMiterlimit: 8,
  shapeRendering: "crispEdges"
}), React.createElement("path", {
  d: "m13.127 27.534h6.9098",
  shapeRendering: "crispEdges",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("rect", {
  x: 8.5641,
  shapeRendering: "crispEdges",
  y: 22.559,
  width: 2.0463,
  height: 1.9991,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("rect", {
  x: 8.5851,
  shapeRendering: "crispEdges",
  y: 26.555,
  width: 1.9828,
  height: 1.9779,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}));
var SvgMenuQuestionsIcon = function SvgMenuQuestionsIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuQuestionsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-questions-icon.a8c5a344.svg";
export { ForwardRef as ReactComponent };